export enum RepositoriesTabKeys {
  BRANCHES = 'BRANCHES',
  HARDENING = 'HARDENING',
  ISSUES = 'ISSUES',
  OVERVIEW = 'OVERVIEW',
  DIFFS = 'DIFFS',
  PULLREQUESTS = 'PULLREQUESTS',
  PULLREQUESTSREPORT = 'PULLREQUESTSREPORT',
  SETTINGS = 'SETTINGS',
}

export enum EnvironmentsTabKeys {
  OVERVIEW = 'OVERVIEW',
  ISSUES = 'ISSUES',
  SCANS = 'SCANS',
  SCANSOVERVIEW = 'SCANSOVERVIEW',
  SCANSREPORT = 'SCANSREPORT',
  SETTINGS = 'SETTINGS',
}
